import React, { useState } from "react";
import "./trivvyCommonComponents.css";
import { GrCloudComputer } from "react-icons/gr";
import { HiLibrary } from "react-icons/hi";
import { HiOutlineUpload } from "react-icons/hi";
import { MdOutlineEditNote } from "react-icons/md";
import { isMobile } from "../../utils/deviceInfo";

export default function SourceSelector({ selectedSource, onSelectSource ,totalLibraryItems}) {
    const [hovered,setHovered] = useState(null)
  const webIcon = (stroke) => {
    return (
      <svg
        stroke="white"
        fill="currentColor"
        stroke-width="0"
        viewBox="0 0 24 24"
        class="wcj"
        color="plain"
        height="50"
        width="50"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="none"
          stroke={stroke}
          stroke-width="2"
          d="M6,6 L6,5 C6,2 7.5,1 10,1 L14,1 C16.5,1 18,2.5 18,5 L18,6 C21,6 23,8 23,11 C23,14 21,16 18,16 M14,6 L6,6 C3,6 1,7.5 1,11 C1,14.5 3,16 6,16 M8,19 L16,19 L16,12 L8,12 L8,19 Z M12,19 L12,23 L12,19 Z M9,23 L15,23 L9,23 Z"
        ></path>
      </svg>
    );
  };

  const sourceOptions = [
    {
      name: "Upload file",
      value: 1,
      icon: <HiOutlineUpload size={50} />,
    },
    {
      name: "Webpage",
      value: 3,
    },
    
   
  
    {
      name: "Custom text",
      value: 2,
      icon: <MdOutlineEditNote size={50} />,
      subText:"(Type or cut and paste)"
    },
    // {
    //   name: "Library",
    //   value: 0,
    //   icon: <HiLibrary size={50} />,
    //   disabled:totalLibraryItems === 0,
    //   subText:totalLibraryItems === 0 ? "(No items in library)":""
    // },
  ];

  return (
    <div className="source_options_boxes_wrapper my-3">
      {sourceOptions.map((s) => {
        return (
          <div
            className={`source_options_box ${
              s.value == selectedSource ? "selected" : ""
            } ${s.disabled ? "disabled":""}`}
            onClick={() => {
              onSelectSource(s.value);
            }}
            onMouseEnter={()=>{
                setHovered(s.value)
            }}
            onMouseLeave={()=>{
                setHovered(null)
            }}
          >
            <div className="my-2">
              {s.icon
                ? s.icon
                : webIcon(s.value == selectedSource || hovered == s.value ? "white" : "black")}
            </div>
            <div
              style={{
                fontSize: isMobile ? "11px" : "15px",
              }}
            >
              {s.name}
            </div>
            {
              s.subText && <div className="font-11px">
              {s.subText}
            </div>
            }
            
          </div>
        );
      })}
    </div>
  );
}
